import {IS_NEW_TIMETABLE_UI} from '../config/config';

/**
 * Tickets / courses / subscription page path segment under `/e/:eid/…`
 * (same rules as realtime TicketsTicket / menu).
 */
export default function getTicketsPagePath(event?: {type?: string | null; eid?: number | null} | null): string {
    if(event?.type === 'course') {
        return 'courses';
    }
    if(event?.type === 'subscription') {
        return 'subscription';
    }
    if(event?.type === 'timetable' && event.eid && IS_NEW_TIMETABLE_UI(event.eid)) {
        return 'timetable/tickets';
    }
    return 'tickets';
}
